export default "__VITE_ASSET__253e314e__"